import { Toast as BaseToast } from '@base-ui/react/toast'
import { Button } from '../../button'
import type { PartProps } from '../../../lib/part-props'

interface ToastActionProps extends PartProps<BaseToast.Action.Props> {}

/** A ghost small Button; in practice "Undo". Its label comes from the toast's `actionProps`. */
function ToastAction({ render, ...props }: ToastActionProps) {
  return (
    <BaseToast.Action
      data-slot="toast-action"
      render={render ?? <Button variant="ghost" size="sm" className="shrink-0" />}
      {...props}
    />
  )
}

export { ToastAction }
